var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconFit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.69266 0.94423C3.69266 0.646052 3.90273 0.430701 4.19571 0.430701C4.49422 0.430701 4.71533 0.651574 4.71533 0.94423V3.82662C4.71533 4.38432 4.38918 4.70458 3.83639 4.70458H0.934222C0.635713 4.70458 0.409068 4.49475 0.409068 4.19658C0.409068 3.8984 0.635713 3.68857 0.934222 3.68857H1.35987L3.12329 3.79348L1.73025 2.47929L0.154783 0.905577C0.0552795 0.800663 0 0.668139 0 0.524572C0 0.209829 0.232174 0 0.547266 0C0.685465 0 0.812607 0.0496964 0.906582 0.149089L2.47652 1.72833L3.7977 3.1143L3.69266 1.36389V0.94423Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16914 5.28989H9.07131C9.36982 5.28989 9.59093 5.50524 9.59093 5.80342C9.59093 6.10159 9.36429 6.31142 9.07131 6.31142H8.64013L6.87671 6.20651L8.26976 7.5207L9.84522 9.09442C9.94472 9.19381 10 9.32633 10 9.47542C10 9.79016 9.76783 9.99999 9.45273 9.99999C9.31454 9.99999 9.19292 9.9503 9.09342 9.8509L7.52348 8.27167L6.20231 6.88017L6.31286 8.63611V9.05024C6.31286 9.34842 6.09727 9.56929 5.80429 9.56929C5.50579 9.56929 5.2902 9.3429 5.2902 9.05024V6.16786C5.2902 5.61568 5.61082 5.28989 6.16914 5.28989Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconFit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-fit.f66cd02140c6e925e74ef209ea8a9815.svg";